import { FC } from 'react';

import { formatCost } from 'utils/clickme';
import { Settings } from 'utils/constants/dynamicSettings';

import { Button, VSpacing } from '@hh.ru/magritte-ui';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';
import useSettings from 'hooks/useSettings';

import BalanceReplenishmentModal from 'components/common/BalanceReplenishmentModal/BalanceReplenishmentModal';
import { CardCommonContent } from 'components/CpcFlexibleCreate/SourcesAndBudgetsSidebar/CardCommonContent/CardCommonContent';

const TrlKeys = {
    title: 'AdCreate.AdForm.AdSources.SourceDisableCard.LowBalance.title',
    text: 'AdCreate.AdForm.SourceDisableCard.LowBalance.text',
    button: 'AdCreate.AdForm.AdSources.SourceDisableCard.LowBalance.button',
};

export const LowBalanceCard: FC = () => {
    const [
        isBalanceReplenishmentModalVisible,
        setIsBalanceReplenishmentModalVisibleOn,
        setIsBalanceReplenishmentModalVisibleOff,
    ] = useOnOffState(false);

    const trls = useTrls();
    const settings = useSettings();

    const minBudget = settings(Settings.NormalMinBudget) as number;

    return (
        <CardCommonContent
            title={trls(TrlKeys.title, [formatCost(minBudget)])}
            text={trls(TrlKeys.text)}
            style="negative-secondary"
        >
            <VSpacing default={20} />
            <Button
                mode="primary"
                style="neutral"
                size="small"
                onClick={setIsBalanceReplenishmentModalVisibleOn}
                data-qa="show-replenishment-modal-from-source-disable-card"
            >
                {trls(TrlKeys.button)}
            </Button>

            <BalanceReplenishmentModal
                withDescription={false}
                isVisible={isBalanceReplenishmentModalVisible}
                closeModal={setIsBalanceReplenishmentModalVisibleOff}
            />
        </CardCommonContent>
    );
};
